import { Button } from '@aod/ui/components/ui/button';
import { Volume2, VolumeX } from 'lucide-react';
import { useState } from 'react';
import { useT } from '../../i18n/index.js';
import { useSettings } from '../useSettings.js';
import { SliderRow } from './shared.js';

export function AudioTab() {
  const t = useT();
  const masterVolume = useSettings((s) => s.masterVolume);
  const musicVolume = useSettings((s) => s.musicVolume);
  const sfxVolume = useSettings((s) => s.sfxVolume);
  const setMasterVolume = useSettings((s) => s.setMasterVolume);
  const setMusicVolume = useSettings((s) => s.setMusicVolume);
  const setSfxVolume = useSettings((s) => s.setSfxVolume);
  const [muted, setMuted] = useState(false);

  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={() => setMuted(!muted)}
          className="size-7"
          aria-label={muted ? t('settings.unmute') : t('settings.mute')}
        >
          {muted ? (
            <VolumeX className="size-4 text-muted-foreground" />
          ) : (
            <Volume2 className="size-4 text-foreground" />
          )}
        </Button>
        <span className="text-sm font-medium text-foreground">{t('settings.tab.audio')}</span>
      </div>
      <SliderRow
        label={t('settings.audio.master')}
        value={masterVolume}
        min={0}
        max={1}
        step={0.05}
        onChange={setMasterVolume}
        muted={muted}
      />
      <SliderRow
        label={t('settings.audio.music')}
        value={musicVolume}
        min={0}
        max={1}
        step={0.05}
        onChange={setMusicVolume}
        muted={muted}
      />
      <SliderRow
        label={t('settings.audio.sfx')}
        value={sfxVolume}
        min={0}
        max={1}
        step={0.05}
        onChange={setSfxVolume}
        muted={muted}
      />
    </div>
  );
}
